import React, { type FC } from 'react'

import { SPACING_40, SpacingVertical } from 'mailup-web-components'

const Spacing: FC = () => {
  return <SpacingVertical variant={SPACING_40} />
}

export default Spacing
